<!--
  *@name ModifyUserInfoModal.vue
  *@author linhongzhou
  *@date 2025-03-19 15:15
  *@description 修改负责人弹框
-->
<template>
  <div>
    <a-modal centered
             :title="title"
             :width="600"
             :visible="visible"
             @ok="handleOk"
             @cancel="handleCancel"
             cancelText="关闭"
             okText="保存"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
        <a-form-item label="负责人">
          <div style="display: flex;padding-top: 5px">
            <a-input
              style="width: auto;border-radius: 4px 0 0 4px"
              placeholder="请选择负责人"
              disabled
              v-decorator="['realname', validatorRules.realname]"
            />
            <a-button type="primary" @click.stop="searchUser" style="border-radius: 0 4px 4px 0">选择</a-button>
          </div>
        </a-form-item>
        <a-form-item label="负责人头像">
          <JImageUpload v-model="avatarUrl" file-type="image" />
          <div class="upload-tips">照片要求：建议上传1寸大小的图片</div>
        </a-form-item>
      </a-form>
    </a-modal>
        <select-user-modal ref="selectUserModal"  :onlySelectOne="true"  @selectChoosed="selectOK"></select-user-modal>
  </div>
</template>

<script>
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import SelectUserModal from './SelectUserModal.vue'
import { httpAction, postAction } from '@api/manage'
export default {
  name: 'ModifyUserInfoModal',
  components: {
    SelectUserModal,
    JImageUpload
  },
  data() {
    return {
      title: '修改负责人',
      visible: false,
      form: this.$form.createForm(this),
      formData:{},   /// 表单对象
      recordChoose:{},  /// 传入的车间负责人record
      selectData:{},  /// 修改后的负责人
      avatarUrl: '',  /// 负责人头像
      validatorRules:{
        realname:{
          rules: [{ required: true, message: '请选择负责人!' }]
        },
      }
    }
  },
  emits:["success"],
  methods: {
    open(record){
      this.visible = true
      const that = this
      // 清空表单缓存
      this.form.resetFields();
      this.formData = {};
      this.avatarUrl = '';
      this.selectData = {};
      this.recordChoose = {};

      this.avatarUrl = record.userHeaderUrl || '';
      this.recordChoose = record;
      console.log(record, '000000000000000000000000');
      this.$nextTick(() => {
        that.form.setFieldsValue({ realname: record.userName});
      })
    },
    handleCancel(){
      this.visible = false
    },
    handleOk(){
      console.log(this.selectData, '<<<<<<<<<selectData')
      console.log(this.recordChoose, '<<<<<<<<<recordChoose')
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          that.confirmLoading = true;
          let params = {
            workshopId: that.recordChoose.workshopId,
            id: that.recordChoose.id,
            userName: that.selectData.realname? that.selectData.realname : that.recordChoose.userName,
            userNo: that.selectData.username? that.selectData.username : that.recordChoose.userNo,
            userHeaderUrl: that.avatarUrl,
          };
          console.log("表单提交数据", params)

          postAction("/workshop/busInspectionWorkshopWorker/edit", params).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('success');
            } else {
              that.$message.error(res.message);
            }
          }).finally(() => {
            this.visible = false
          })

        }
      })
    },
    searchUser(){
      this.$refs.selectUserModal.add()
    },
    selectOK(selectData){
      this.form.setFieldsValue({ realname: selectData[0].realname })
      this.selectData = selectData[0];
      this.avatarUrl = ''
    },
  }
}
</script>

<style lang="less" scoped>
.flex-end{
  display: flex;
  justify-content: flex-end;
}
.upload-tips{
  color: red;
  font-size: 12px;
  line-height: 12px;
}
</style>
